import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css, Global } from '@emotion/react';
import { FocusStyleManager, palette } from '@guardian/source/foundations';
import { useEffect } from 'react';
import { SkipLink } from 'components/skipLink/skipLink';
import { TestUserBanner } from 'components/test-user-banner/testUserBanner';
import { useScrollToAnchor } from 'helpers/customHooks/useScrollToAnchor';
import { guardianFonts } from 'stylesheets/emotion/fonts';
import { reset } from 'stylesheets/emotion/reset';
const container = css `
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	max-width: 100%;
	overflow-x: hidden;
	background-color: ${palette.brand[400]};

	& main {
		flex: 1;
		display: flex;
		flex-direction: column;

		& > :last-child {
			display: flex;
			flex: 1;
		}
	}
`;
export function PageScaffold({ id, header, footer, children, }) {
    useScrollToAnchor();
    useEffect(() => {
        FocusStyleManager.onlyShowFocusOnTabs();
    }, []);
    return (_jsxs("div", { id: id, css: container, children: [_jsx(Global, { styles: [reset, guardianFonts] }), _jsxs("nav", { "aria-label": "Skip to section", children: [_jsx(SkipLink, { id: "maincontent", label: "Skip to main content" }), _jsx(SkipLink, { id: "navigation", label: "Skip to navigation" })] }), _jsx(TestUserBanner, {}), header, _jsx("main", { role: "main", id: "maincontent", children: children }), footer] }));
}
